<div class="ft2-html-editor" [class.-plain]="plain">
    <div class="ft2-html-editor-container">
        <div class="ft2-html-editor-panel" [class.-inactive]="activeEditorIndex === null" *ngIf="!plain">
            <ng-select *ngIf="tokens?.length"
                       class="ft2-select -small -pure mr-2 -no-border"
                       [items]="tokens"
                       [bindLabel]="'name'"
                       [bindValue]="'value'"
                       [(ngModel)]="selectedToken"
                       [clearable]="false"
                       [searchable]="false"
                       [placeholder]="'Insert token'"
                       (ngModelChange)="onTokenSelected($event)" />
            <!-- FTK-7509: `(mousedown)` prevented for the same reason every button in
                 `rich-text-editor.component.html` does it — a plain click here focuses the button,
                 which blurs the editor, which nulls `activeEditorIndex`, which adds `-inactive`
                 (`pointer-events: none`) to this panel BEFORE the mouseup lands. Verified in the
                 browser on the Confirmation Experience "Share Message" editor: without this the
                 source-view toggle is unreachable — the click is swallowed and no editor mounts. -->
            <button class="ft2-btn-pure p-1" type="button"
                    *ngIf="!plain && isFormatVisible('html')"
                    [class.text-secondary]="isSourceCodeVisible"
                    (mousedown)="$event.preventDefault()"
                    (click)="changeFormat()">
                <mat-icon class="icon-md">code</mat-icon>
            </button>
        </div>
        <!-- ONE toolbar for the whole field group, driven by whichever editor is focused.
             It used to be rendered inside `ft-rich-text-editor`, i.e. once per field, and since
             `_editors.scss` positions it `absolute; top: 0` against this container every copy landed
             on the same rect. Only the focused editor's copy took `.ql-active`, and the copy painted
             on top was the LAST one in the DOM — so bolding in the first field lit a button hidden
             under a dimmed duplicate and looked like nothing happened.

             Hidden in the source view for the same reason it always was: the rich-text editors are
             destroyed there, so a format command would have no editor to act on. -->
        <div quill-editor-toolbar
             class="ql-toolbar ql-snow"
             *ngIf="!plain && !isSourceCodeVisible"
             [class.inactive]="activeEditorIndex === null">
            <span class="ql-formats">
                <button *ngIf="isFormatVisible('bold')"
                        type="button"
                        class="ql-bold"
                        [title]="'Bold'"
                        [class.ql-active]="activeFormats.bold"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('bold')">
                    <mat-icon class="icon-md">format_bold</mat-icon>
                </button>
                <button *ngIf="isFormatVisible('italic')"
                        type="button"
                        class="ql-italic"
                        [title]="'Italic'"
                        [class.ql-active]="activeFormats.italic"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('italic')">
                    <mat-icon class="icon-md">format_italic</mat-icon>
                </button>
                <button *ngIf="isFormatVisible('underline')"
                        type="button"
                        class="ql-underline"
                        [title]="'Underline'"
                        [class.ql-active]="activeFormats.underline"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('underline')">
                    <mat-icon class="icon-md">format_underlined</mat-icon>
                </button>
                <button *ngIf="isFormatVisible('link')"
                        type="button"
                        class="ql-link"
                        [title]="'Link'"
                        [class.ql-active]="activeFormats.link"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('link')">
                    <mat-icon class="icon-md">link</mat-icon>
                </button>
                <button *ngIf="isFormatVisible('ordered')"
                        type="button"
                        class="ql-list"
                        [title]="'Numbered list'"
                        [class.ql-active]="activeFormats.ordered"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('ordered')">
                    <mat-icon class="icon-md">format_list_numbered</mat-icon>
                </button>
                <button *ngIf="isFormatVisible('bullet')"
                        type="button"
                        class="ql-list"
                        [title]="'Bulleted list'"
                        [class.ql-active]="activeFormats.bullet"
                        (mousedown)="$event.preventDefault()"
                        (click)="applyFormat('bullet')">
                    <mat-icon class="icon-md">format_list_bulleted</mat-icon>
                </button>
            </span>
            <div class="ql-tooltip" *ngIf="linkEditorOpen">
                <input #linkInput
                       type="url"
                       class="ql-tooltip_url"
                       placeholder="https://"
                       [value]="linkDraft"
                       (keydown.enter)="$event.preventDefault(); commitLink(linkInput.value)"
                       (keydown.escape)="closeLinkEditor()">
                <button type="button" class="ql-action" (click)="commitLink(linkInput.value)">Apply</button>
                <button type="button" class="ql-remove" (click)="removeLink()">Remove</button>
                <button type="button" class="ql-cancel" (click)="closeLinkEditor()">Cancel</button>
            </div>
        </div>

        <div class="ft2-html-editor-wrapper"
             [id]="field.name + i"
             [ngClass]="{'-border-top': last, '-has-label': !!field?.label?.trim()?.length, '-plain': plain && !field?.label?.trim()?.length}"
             *ngFor="let field of fields; let i = index; let last = last;">
            <ng-container *ngIf="model">
                <ng-container *ngTemplateOutlet="editorsTemplate; context: {model: model[field.name], field: field, index: i, containerId : '#' + field.name + i}" />
            </ng-container>
        </div>
        <div *ngIf="!fields" class="ft2-html-editor-wrapper">
            <ng-container *ngTemplateOutlet="editorsTemplate; context: {model: model, index: 0}" />
        </div>


        <ng-template #editorsTemplate let-model="model" let-field="field" let-i="index" let-containerId="containerId">
            <div class="ft2-html-editor_label" *ngIf="field && !!field?.label?.trim()?.length">
                {{field.label}}
            </div>
            <ft-rich-text-editor
                    *ngIf="!isSourceCodeVisible && visible"
                    [ngModel]="model"
                    class="text-content"
                    (ngModelChange)="onModelChanged($event, field)"
                    [placeholder]="placeholder"
                    [plainClipboard]="trimClipboardFormat"
                    (editorBlur)="onBlur(i)"
                    (editorFocus)="onFocus(i)"
                    (editorCreated)="onRichTextEditorCreated($event, i)" />
            <!-- FTK-7509. `(editorFocus)` is a real component output; the `(focus)`/`(blur)` this
                 replaces were NATIVE host listeners that never fired, because the editable node is
                 CodeMirror's `.cm-content` descendant and focus/blur do not bubble (and neither this
                 component nor `<ngx-monaco-editor>` before it declared outputs by those names). So
                 `activeEditorIndex` was never set while the source view was open and picking a token
                 silently inserted nothing.

                 🚨 Blur is deliberately NOT wired, and that is the whole fix — not an omission.
                 `onBlur` nulls `activeEditorIndex` whenever `fields` is set, and picking a token
                 moves focus to the <ng-select>. Wiring blur here would null the index between the
                 dropdown opening and the token arriving, putting the source view straight back to
                 inserting nothing — and it would also re-dim this panel (`-inactive` is
                 `pointer-events: none`) while the dropdown it disables is still open. Nothing
                 regresses by leaving it unbound: the binding it replaces never fired either. The
                 caret itself needs no saving, unlike the Quill case in `insertTokenInRichText` —
                 CodeMirror keeps its selection in `EditorState` across a DOM blur, so
                 `insertText()` re-focuses and replaces that same selection. -->
            <ft-code-mirror *ngIf="isSourceCodeVisible"
                    (editorFocus)="onFocus(i)"
                    (paste)="trimUnbreakableSpaceOnPaste($event, field)"
                    (ready)="codeEditorCreated($event, i);"
                    [ngModel]="model"
                    (ngModelChange)="onModelChanged($event, field)"
                    [language]="'html'" />
        </ng-template>
    </div>
    <ng-container *ngIf="!fields">
        <div>
            <input [ngModel]="model"
                   [required]="required"
                   [minlength]="minlength"
                   [maxlength]="maxlength"
                   #input="ngModel"
                   type="hidden">
            <div class="ft2-form-error"
                 *ngIf="input.invalid">
                <p>Contains an error:</p>
                <div *ngIf="input.errors.required">
                    Value is required.
                </div>
                <div *ngIf="input.errors.minlength">
                    Value must be at least {{minlength}} characters long.
                </div>
                <div *ngIf="input.errors.maxlength">
                    Value must be at most {{maxlength}} characters long. <br>
                    Keep in mind that stylization tags are also counted toward the maximum length.
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!!fields">
        <div *ngFor="let field of fields; let i=index;">
            <ng-container *ngIf="model">
                <input [ngModel]="model[field.name]"
                       [required]="required"
                       [minlength]="minlength"
                       [maxlength]="maxlength"
                       #input="ngModel"
                       type="hidden">
                <div class="ft2-form-error"
                     *ngIf="input.invalid">
                    <p>{{field.label}} contains an error:</p>
                    <div *ngIf="input.errors.required">
                        Value is required.
                    </div>
                    <div *ngIf="input.errors.minlength">
                        Value must be at least {{minlength}} characters long.
                    </div>
                    <div *ngIf="input.errors.maxlength">
                        Value must be at most {{maxlength}} characters long. <br>
                        Keep in mind that stylization tags are also counted toward the maximum length.
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <p class="text-right solid-text muted-text p-1 pb-2 mr-2" *ngIf="model?.language">
        <small class="uppercase muted-text">{{model.language}}</small>
    </p>
    <ng-container *ngIf="!model?.language">
        <ng-container *ngFor="let field of fields">
            <p class="text-right solid-text muted-text p-1 pb-2 mr-2"
               *ngIf="totalEntries > 1">
                <small class="uppercase muted-text">{{model && model[field.languageName]}}</small>
            </p>
        </ng-container>
    </ng-container>
</div>
